import { newRequest, oldRequest } from "./complexRequest"
import { PageQueryFn, PageResponse, ResponseType } from "./type"


// 获取机器人列表
export const getRobotoList: PageQueryFn<{
  categories?: number,
  locale?: string
}> = async (params, option = {}, useFetch = true) => {
  return newRequest<PageResponse>({
    url: '/client/common/recommend/categories',
    method: 'get',
    params,
    ...option
  }, useFetch)
}

// 搜索机器人
export const searchRoboto: PageQueryFn<{
  gender?: number | number[],
  sort?: string
  categories?: number
  info_token?: number[]
  language?: string[]
  keyword: string // 搜索建
}> = async (data, option = {}, useFetch = true) => {
  return newRequest<PageResponse>({
    url: '/client/common/robot/search',
    data,
    method: "post",
    ...option
  }, useFetch)
}

// 搜索群组
export const searchGroup: PageQueryFn<{ keyword: string }> = async (data, option = {}, useFetch = true) => {
  return newRequest<ResponseType<any>>({
    url: '/client/common/robot/search_group',
    data,
    method: 'post',
    ...option
  }, useFetch)
}

// 搜索创作者（作者）
export const searchCreator: PageQueryFn<{ name: string }> = async (data, option = {}, useFetch = true) => {
  return oldRequest<ResponseType<any>>({
    url: '/Api/User/search',
    data,
    method: 'post',
    ...option
  }, useFetch)
}

// 搜索机器人
export const recommendRobot = async (data, option = {}, useFetch = true) => {
  return newRequest<any>({
    url: '/client/common/recommend/discover',
    data,
    ...option
  }, useFetch)
}



// 分类
export interface Category {
  cid: number,
  name: string,
  description: string,
  status: number,
  sequence?: number,
  other_lang?: string
}

export const getRobotoCategories: PageQueryFn = async (data, option = {}, useFetch = true) => {
  return oldRequest<PageResponse<Category>>({
    url: '/Api/Categories/index',
    data,
    ...option
  }, useFetch)
}

// 获取机器人的HashTag
export const getHashtags = async (option = {}, useFetch = true) => {
  return newRequest<PageResponse>({
    url: '/client/robot/selected-tags',
    method: 'get',
    ...option
  }, useFetch)
}

// sitemap 专用：游标分页拉取全量公开机器人 id + lastmod
export interface RobotSitemapItem { id: number, lastmod: number }
export interface RobotSitemapResponse {
  status: number
  data: { list: RobotSitemapItem[], cursor: string, has_more: boolean, total: number }
}
// 注意：后端 limit 上限锁定为 5000；total 仅首次(空 cursor)精确
export const getRobotSitemap = async (
  params: { cursor?: string, limit?: number },
  option = {},
  useFetch = true,
) => {
  return oldRequest<RobotSitemapResponse>({
    url: '/Api/Robots/sitemap',
    data: { limit: 5000, cursor: '', ...params },
    ...option,
  }, useFetch)
}

// 关注的机器人
export const followRobot = async (data, option = {}, useFetch = true) => {
  return oldRequest<PageResponse<Category>>({
    url: '/Api/Robots/index',
    data,
    ...option
  }, useFetch)
}